var SpSlide = {
	current: 0,
	max: 0,
	wh: [],
	w: 0,
	mr: 0,
	mrp: 0, //マージンの%
	hasPC: false
}
var sp_slides = [];
var spSlideshow = {
	flag: true,
	init: function(){
		$(".slideshow.sp_slide").each(function(i){
			let _s = object(SpSlide);
			_s.current 	= 0;
			_s.max 		= $(this).find(".slideshow_content li").length;
			_s.wh[0]	= $(this).attr("data-x");
			_s.wh[1]	= $(this).attr("data-y");
			_s.mr 		= $(this).attr("data-margin");
			sp_slides.push(_s);
			let navHTML = "";
			$(this).find(".slideshow_content li").each(function(j){
				navHTML += '<li><a href="javascript:void(0);" title="' + j + '">' + j + '</a></li>';
			});
			$(this).find(".pagination_slideshow").html(navHTML);
			$(this).find("a.btn_slide_prev").attr("data-num", i);
			$(this).find("a.btn_slide_next").attr("data-num", i);

			//clone
			let $first = $(this).find(".slideshow_content li:first-child").clone().addClass("clone");
			let $first2 = $(this).find(".slideshow_content li").eq(1).clone().addClass("clone");

			let $last  = $(this).find(".slideshow_content li:last-child").clone().addClass("clone");
			let $last2  = $(this).find(".slideshow_content li").eq( $(this).find(".slideshow_content li").length-2 ).clone().addClass("clone");

			
			$(this).find("ul.slideshow_content").prepend($last);
			$(this).find("ul.slideshow_content").prepend($last2);

			$(this).find("ul.slideshow_content").append($first);
			$(this).find("ul.slideshow_content").append($first2);
		});
		canResize = true;
		//console.log(sp_slides)
		spSlideshow.resize();
		spSlideshow.nav();
	},
	resize: function(){
		if(isSmallScreen){
			$(".slideshow.sp_slide").each(function(i){
				let name = $(this).attr("data-name");
				if(winSize != 1){
					let winW = $(this).width();
					let s = sp_slides[i];
					s.wh[0] = Math.floor( $(this).find(".slideshow_content li").width() );
					s.wh[1] = Math.floor( $(this).find(".slideshow_content li").outerHeight() );
					s.mrp 	= Math.floor( s.mr/winW * winW);
					//console.log(s.wh, s.mrp)
					let perW 	= s.wh[0] / winW;
					let half 	= Math.floor(( winW - $(this).find(".slideshow_content li").width() )/2),
						_left 	= Math.floor( -s.current*s.wh[0] - s.mrp + half - s.mrp*s.current);
					$(this).find(".slideshow_content li").each(function(j){
						let count = j - 2;
						$(this).css({
							"left": Math.floor( count*(s.wh[0] + s.mrp) + s.mrp) + "px"
						});
					});
					$(this).find(".slideshow_content").css({
						"transform": "translate3d(" + _left + "px, 0, 0)"
					});
					$(this).find(".pagination_slideshow li a").removeClass("active");
					$(this).find(".pagination_slideshow li").eq(s.current).find("a").addClass("active");
					
				}else{
					$(".slideshow.sp_slide").each(function(i){
						$(this).find(".slideshow_content li").each(function(j){
							$(this).css({
								"left": ""
							});
						});
						$(this).find(".slideshow_content").css({
							"transform": ""
						});
					});
				}
			});
		}else{
			$(".slideshow.sp_slide").each(function(i){
				$(this).find(".slideshow_content li").each(function(j){
					$(this).css({
						"left": ""
					});
				});
				$(this).find(".slideshow_content").css({
					"transform": ""
				});
			});
		}
	},
	nav: function(){
		$(".sp_slide a.btn_slide_prev").off().on("click", function(){
			let idx = $(this).attr("data-num");
			spSlideshow.dec(idx);
		});
		$(".sp_slide a.btn_slide_next").off().on("click", function(){
			let idx = $(this).attr("data-num");
			spSlideshow.inc(idx);
		});
		//for smartphone touch event
		var cx, positionX, limitX = 80, touchIdx;
		removeTouch();
		addTouchEvent();

		function addTouchEvent(){
			$(".slideshow.sp_slide").each(function(i){
				let $touchBlock = $(this).find(".block_touch")[0];
				$touchBlock.addEventListener("touchstart", touchStart, {passive: true});
				$touchBlock.addEventListener("touchmove", touchMove, {passive: true});
				$touchBlock.addEventListener("touchend", touchEnd, {passive: true});
				$touchBlock.addEventListener("touchcancel", touchCancel, {passive: true});
			});
		}
		function removeTouch(){
			$(".slideshow.sp_slide").each(function(i){
				let $touchBlock = $(this).find(".block_touch")[0];
				$touchBlock.removeEventListener("touchstart", touchStart, {passive: true});
				$touchBlock.removeEventListener("touchmove", touchMove, {passive: true});
				$touchBlock.removeEventListener("touchend", touchEnd, {passive: true});
				$touchBlock.removeEventListener("touchcancel", touchCancel, {passive: true});
			});
		}

		function touchStart(e){
			touchIdx = $(".slideshow.sp_slide").index($(e.currentTarget).parent());
			cx 			= 0;
			positionX 	= getPosition(e);
		}
		function touchMove(e){
			cx 	= positionX - getPosition(e);
		}
		function touchEnd(e){
			if(cx <= -limitX){
				spSlideshow.dec(touchIdx);
			}else if(cx >= limitX){
				spSlideshow.inc(touchIdx);
			}else{
			}
		}
		function touchCancel(e){
			cx = 0;
		}
		function getPosition(event){
			return event.touches[0].pageX;
		}
	},
	dec: function(idx){
		let s = sp_slides[idx];
		if(spSlideshow.flag){
			spSlideshow.flag = false;
			s.current--;
			spSlideshow.change(idx);
		}
	},
	inc: function(idx){
		let s = sp_slides[idx];
		if(spSlideshow.flag){
			spSlideshow.flag = false;
			s.current++;
			spSlideshow.change(idx);
		}
	},
	change: function(idx){
		spSlideshow.resize();
		spSlideshow.nav();
		setTimeout(function(){
			spSlideshow.resetPos(idx);
			spSlideshow.flag = true;
		}, 500)
	},
	resetPos: function(i){
		let s = sp_slides[i];
		console.log(i)
		if(s.current >= s.max){
			s.current = 0;
			$(".sp_slide").eq(i).find(".slideshow_content").addClass("notransition");
			setTimeout(function(){
				spSlideshow.resize();
				setTimeout(function(){
					$(".sp_slide").eq(i).find(".slideshow_content").removeClass("notransition");
				},50);
			}, 50);
		}else if(s.current < 0){
			s.current = s.max-1;
			$(".sp_slide").eq(i).find(".slideshow_content").addClass("notransition");
			setTimeout(function(){
				spSlideshow.resize();
				setTimeout(function(){
					$(".sp_slide").eq(i).find(".slideshow_content").removeClass("notransition");
				},50);
			}, 50);
		}
		
	}
}